import React from "react";

import style from "./style.module.css";
import common from "../Input/style.module.css"

export default function FormGroup(props) {
    const {
        children = false,
        label = false,
        required = false,
        focus = false,
        value = "",
        meta = {},
        helpText = true,
        inputType = "",
        disabled = false
    } = props;

    const { touched = false, error = "" } = meta;
    const isShow = touched && error && helpText && !disabled;

    return (
        <div className={`${style.formGroup}${isShow ? " " + style.inputError : ""}${focus ? " " + style.inputFocus : ""}${inputType && isShow ? " " + style[`${inputType}Error`] : ""}`}>
            {
                label !== false && (
                    <div className={`${style.controlLabel}${focus || value ? " " + style.focus : ""}${disabled ? " " + style.inputDisabled : ""}${inputType ? " " + style[inputType] : ""}`}>
                        <span>{label}</span>
                        {
                            required && (
                                <span className={style.required}> *</span>
                            )
                        }
                    </div>
                )
            }
            <div className={`${label === false ? style.noLabel : ""} ${style.inputFieldBox}`}>
                {
                    disabled === false && (
                        children
                    )
                }
                {
                    disabled === true && (
                        <div className={`${common.textbox} ${style.inputDisabled}`}>
                            {value || <>&nbsp;</>}
                        </div>
                    )
                }
            </div>
            {
                isShow && (
                    <p className={style.helpBlock}>{error}</p>
                )
            }
        </div >
    )
}